export default function Skeleton() {
  return <div className='homepage-container absolute left-0 top-0 h-[145px] w-full lg:h-[190px]' data-sentry-component="Skeleton" data-sentry-source-file="skeleton.tsx">
            <div className='flex h-full w-full items-center justify-between bg-gray-100 py-3'>
                <div className='h-full w-[5%] animate-pulse rounded-l bg-white lg:w-[29%]'></div>
                <div className='h-full w-[85%] animate-pulse rounded bg-white lg:w-[40%]'></div>
                <div className='h-full w-[5%] animate-pulse rounded-r bg-white lg:w-[29%]'></div>
            </div>
        </div>;
}